import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppDomService {
  constructor() {}

  static hideAppScroll() {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  }

  static showAppScroll() {
    document.getElementsByTagName('html')[0].style.overflow = 'initial';
  }

  static hideScrollblock() {
    document
      .getElementsByTagName('html')[0]
      .classList.remove('cdk-global-scrollblock');
  }

  static isDarkMode(): boolean {
    return document.getElementsByTagName('html')[0].classList.contains('dark');
  }

  static removeModalScrollClassFromHtml() {
    document
      .getElementsByTagName('html')[0]
      .classList.remove('cdk-global-scroll-y');
  }

  static isLTR(): boolean {
    return (
      document.getElementsByTagName('html')[0].getAttribute('dir') == 'ltr'
    );
  }

  static currentLang(): string {
    return document.getElementsByTagName('html')[0].getAttribute('lang');
  }

  static getElementsByQueryAsync(
    querySelector: string,
    prefixSelector?: string,
    timeOut: number = 5,
    maxTimeout: number = 3000
  ): Promise<NodeListOf<Element>> {
    const selector = `${prefixSelector || ''} ${querySelector}`;

    if (!AppDomService.isSelectorValid(selector)) return;

    const promise = new Promise<NodeListOf<Element>>((resolve, reject) => {
      let counter: number = 1;

      const interval = setInterval(() => {
        counter += timeOut;

        const elements = document.querySelectorAll(selector);

        if (elements?.length) {
          clearInterval(interval);
          resolve(elements);
        }

        if (counter > maxTimeout) {
          clearInterval(interval);
          resolve(null);
        }
      }, timeOut);
    });

    return promise;
  }

  static getElementsByClassNameAsync(
    querySelector: string,
    prefixSelector?: string,
    timeOut: number = 5,
    maxTimeout: number = 3000
  ): Promise<HTMLCollectionOf<Element>> {
    const selector = `${prefixSelector || ''} ${querySelector}`;

    const promise = new Promise<HTMLCollectionOf<Element>>(
      (resolve, reject) => {
        let counter: number = 1;

        const interval = setInterval(() => {
          counter += timeOut;

          const elements = document.getElementsByClassName(selector);

          if (elements?.length) {
            clearInterval(interval);
            resolve(elements);
          }

          if (counter > maxTimeout) {
            clearInterval(interval);
            resolve(null);
          }
        }, timeOut);
      }
    );

    return promise;
  }

  static getElementByQueryAsync(
    querySelector: string,
    prefixSelector?: string,
    timeOut: number = 5,
    maxTimeout: number = 3000
  ): Promise<Element> {
    const selector = `${prefixSelector || ''} ${querySelector}`;

    if (!AppDomService.isSelectorValid(selector)) return;

    const promise = new Promise<Element>((resolve, reject) => {
      let counter: number = 1;

      const interval = setInterval(() => {
        counter += timeOut;

        const elements = document.querySelector(selector);

        if (elements) {
          clearInterval(interval);
          resolve(elements);
        }

        if (counter > maxTimeout) {
          clearInterval(interval);
          resolve(null);
        }
      }, timeOut);
    });

    return promise;
  }

  static getElementByIdAsync(
    querySelector: string,
    prefixSelector?: string,
    timeOut: number = 5,
    maxTimeout: number = 3000
  ): Promise<HTMLElement> {
    const selector = `${prefixSelector || ''} ${querySelector}`;

    const promise = new Promise<HTMLElement>((resolve, reject) => {
      let counter: number = 1;

      const interval = setInterval(() => {
        counter += timeOut;

        const elements = document.getElementById(selector);

        if (elements) {
          clearInterval(interval);
          resolve(elements);
        }

        if (counter > maxTimeout) {
          clearInterval(interval);
          resolve(null);
        }
      }, timeOut);
    });

    return promise;
  }

  static queryCheck(selector) {
    document.createDocumentFragment().querySelector(selector);
  }

  static isSelectorValid(selector) {
    try {
      AppDomService.queryCheck(selector);
    } catch {
      return false;
    }
    return true;
  }
}
